(function () {
    'use strict';

    angular
        .module('elogbooksControllers')
        .controller('advancedJobFiltersModalController', advancedJobFiltersModalController);

    advancedJobFiltersModalController.$inject = [
        '$state',
        '$stateParams',
        'config',
        'assetCollectionResponse',
        'chargeTypesCollectionResponse',
        'jobGroupCollectionResponse',
        'serviceProviderResponse',
        'operativeCollectionResponse',
        'jobCollectionResponse',
        'approversCollectionResponse',
        'creatorsCollectionResponse',
        'assetTypeCollectionResponse',
        'siteCollection',
        'statutoryTypeCollectionResponse',
        'priorityCollectionResponse',
        'siteGroupCollection',
        '$uibModalInstance',
        '$rootScope',
        '$scope',
        '$translate',
        'lodash',
        'moment',
        'hierarchyService',
        'paramConverterService',
        'jobStatuses',
        'apiClient',
        'rootResource',
        'jobRequisiteCollectionResponse',
        'sectorCollectionResponse',
        'coreClientsCollectionResponse',
        'serviceProviderGroupsResponse',
        'regionCollectionResponse',
        'filterCriteriaService',
        'userManager',
        'siteResource',
        'elbSettings',
        'jobTypeService',
        'settings',
        'modulesService'
    ];

    function advancedJobFiltersModalController(
        $state,
        $stateParams,
        config,
        assetCollectionResponse,
        chargeTypesCollectionResponse,
        jobGroupCollectionResponse,
        serviceProviderResponse,
        operativeCollectionResponse,
        jobCollectionResponse,
        approversCollectionResponse,
        creatorsCollectionResponse,
        assetTypeCollectionResponse,
        siteCollection,
        statutoryTypeCollectionResponse,
        priorityCollectionResponse,
        siteGroupCollection,
        $uibModalInstance,
        $rootScope,
        $scope,
        $translate,
        lodash,
        moment,
        hierarchyService,
        paramConverterService,
        jobStatuses,
        apiClient,
        rootResource,
        jobRequisiteCollectionResponse,
        sectorCollectionResponse,
        coreClientsCollectionResponse,
        serviceProviderGroupsResponse,
        regionCollectionResponse,
        filterCriteriaService,
        userManager,
        siteResource,
        elbSettings,
        jobTypeService,
        settings,
        modulesService
    ) {

        var vm = this;
        vm.config = config;
        vm.close = close;
        vm.update = update;
        vm.getApprovers = getApprovers;
        vm.getServiceProviders = getServiceProviders;
        vm.getPriorities = getPriorities;
        vm.getStatTypes = getStatTypes;
        vm.saveParams = saveParams;
        vm.getPrioritiesBySite = getPrioritiesBySite;
        vm.getDueBy = getDueBy;
        vm.clear = clear;
        vm.settings = settings;

        vm.p2p = $stateParams.hasOwnProperty('p2p') && ($state.params.p2p === '1' || $state.params.p2pAwaitingPoNumber === '1' || $state.params.p2pAwaitingValue === '1');
        vm.prosureEnabled = elbSettings.getSetting('prosure_enabled').value;
        vm.assetsModuleEnabled = modulesService.isEnabled('assets_module');
        vm.tasksModuleEnabled = modulesService.isEnabled('tasks_module');

        var selectDisabled = false;

        if (siteCollection) {
            if (siteCollection.selected) {
                selectDisabled = true;
            }
        }

        vm.data = {};
        vm.advancedCriteria = {};

        var sourceTypes = [
                {id: 0, value: 'Action',href: 0},
                {id: 2, value: 'Job Remedial', href: 2}
            ];

        if (modulesService.isEnabled('quotes')) {
            sourceTypes.push({id: 3, value: 'Quote', href: 3});
        }

        if (rootResource.canViewAuditSourceType || modulesService.isEnabled('audits_module')) {
            sourceTypes.splice(1, 0, {id: 1, value: 'Audit', href: 1});
        }

        var remedialOptions = [
            {
                title: $translate.instant('NONE_SELECTED'),
                value: null
            },
            {
                title: $translate.instant('YES'),
                value: 'true'
            },
            {
                title: $translate.instant('NO'),
                value: 'false'
            }
        ];

        var watchedJobOptions = [
            {
                title: $translate.instant('NONE_SELECTED'),
                value: null
            },
            {
                title: $translate.instant('YES'),
                value: '1'
            },
            {
                title: $translate.instant('NO'),
                value: '0'
            }
        ];

        const fromVantifyRiskManagerOptions = [
            {
                title: $translate.instant('NONE_SELECTED'),
                value: null
            },
            {
                title: $translate.instant('YES'),
                value: 'meridian'
            },
            {
                // Not meridian (all other possible types)
                title: $translate.instant('NO'),
                value: '!meridian'
            }
        ];

        var prosureStatusesOptions = [
            {
                title: $translate.instant('PROSURE_REQUIREMENTS_SUCCESS'),
                value: '0'
            },
            {
                title: $translate.instant('PROSURE_REQUIREMENTS_EXPIRING'),
                value: '1'
            },
            {
                title: $translate.instant('PROSURE_REQUIREMENTS_BELOW'),
                value: '2'
            },
            {
                title: $translate.instant('PROSURE_SUSPENDED'),
                value: '3'
            },
            {
                title: $translate.instant('VANTIFY_SUPPLY_CHAIN_NOT_LINKED'),
                value: '-1'
            }
        ];

        var overdueOptions = [
            {
                title: $translate.instant('NONE_SELECTED'),
                value: null
            },
            {
                title: $translate.instant('OVERDUE_YES'),
                value: 'true'
            },
            {
                title: $translate.instant('OVERDUE_NO'),
                value: 'false'
            }
        ];

        var frequencyOptions = [
            {
                title: $translate.instant('NONE_SELECTED'),
                value: null
            },
            {
                title: $translate.instant('WEEKLY'),
                value: '4'
            },
            {
                title: $translate.instant('MONTHLY'),
                value: '5'
            },
            {
                title: $translate.instant('YEARLY'),
                value: '6'
            }
        ];

        var frequencyIntervalMin = 1;
        var frequencyIntervalMax = 52;

        var typeOptions = jobTypeService.getFilterOptions();

        var approvalOptions = [
            {
                title: $translate.instant('JOB_PRIMARY_OPERATIVE_APPROVAL'),
                value: "2"
            },
            {
                title: $translate.instant('JOB_APPROVER_APPROVAL'),
                value: "1"
            },
            {
                title: $translate.instant('JOB_PENDING_WITH_ME'),
                value: "0"
            }
        ];

        var completionOptions = [
            {
                title: $translate.instant('NONE_SELECTED'),
                value: null
            },
            {
                title: $translate.instant('JOB_REQUISITE_PENDING_COMPLETION_OPTION'),
                value: "1"
            },
            {
                title: $translate.instant('JOB_REQUISITE_PENDING_WITH_ME'),
                value: "2"
            }
        ];

        function getApprovers() {
            return paramConverterService.formatResponse(approversCollectionResponse.users);
        }

        function getServiceProviders() {
            return paramConverterService.formatResponse(serviceProviderResponse.serviceproviders);
        }

        function getAssetTypes() {
            return paramConverterService.formatResponse(hierarchyService.getJobGroupHierarchy(assetTypeCollectionResponse.assettypes));
        }

        function getPriorities() {
            return paramConverterService.formatResponse(priorityCollectionResponse.priorities);
        }

        function getStatTypes() {
            return paramConverterService.formatResponse(statutoryTypeCollectionResponse.statutorytypes);
        }

        vm.advancedCriteria = {
            jobId: {
                type: 'number',
                title: 'ID',
                value: $stateParams.jobId ? parseInt($stateParams.jobId, 10) : null
            }
        };
        if((!vm.p2p || !vm.settings || vm.settings.allowJobValueOnPlannedJobs) && (rootResource.plannedJobsExist || vm.tasksModuleEnabled)) {
            vm.advancedCriteria.jobsType = {
                type: 'options',
                title: 'JOB_TYPE',
                value: $stateParams.jobsType,
                options: typeOptions
            };
        }
        vm.advancedCriteria.alarmedAtStart = {
                type: 'date',
                title: 'ALARMED_AT_START',
                value: (typeof $stateParams.alarmedAtStart !== 'undefined' && $stateParams.alarmedAtStart !== null) ? moment(new Date($stateParams.alarmedAtStart)) : null,
                maxDependsOn: 'alarmedAtEnd'
        };
        vm.advancedCriteria.alarmedAtEnd = {
                type: 'date',
                title: 'ALARMED_AT_END',
                end: true,
                value: (typeof $stateParams.alarmedAtEnd !== 'undefined' && $stateParams.alarmedAtEnd !== null) ? moment(new Date($stateParams.alarmedAtEnd)) : null,
                minDependsOn: 'alarmedAtStart'
        };
        vm.advancedCriteria.createdAtStart = {
                type: 'date',
                title: 'CREATED_AT_START',
                value: (typeof $stateParams.createdAtStart !== 'undefined' && $stateParams.createdAtStart !== null) ? moment(new Date($stateParams.createdAtStart)) : null,
                maxDependsOn: 'createdAtEnd'
        };
        vm.advancedCriteria.createdAtEnd = {
                type: 'date',
                title: 'CREATED_AT_END',
                end: true,
                value: (typeof $stateParams.createdAtEnd !== 'undefined' && $stateParams.createdAtEnd !== null) ? moment(new Date($stateParams.createdAtEnd)) : null,
                minDependsOn: 'createdAtStart'
        };
        vm.advancedCriteria.completionDueStart = {
                type: 'date',
                title: 'COMPLETION_DUE_AT_START',
                enableDisableJobsDueBy: true,
                value: (typeof $stateParams.completionDueStart !== 'undefined' && $stateParams.completionDueStart !== null) ? moment(new Date($stateParams.completionDueStart)) : null,
                maxDependsOn: 'completionDueEnd'
        };
        vm.advancedCriteria.completionDueEnd = {
                type: 'date',
                title: 'COMPLETION_DUE_AT_END',
                end: true,
                enableDisableJobsDueBy: true,
                value: (typeof $stateParams.completionDueEnd !== 'undefined' && $stateParams.completionDueEnd !== null) ? moment(new Date($stateParams.completionDueEnd)) : null,
                minDependsOn: 'completionDueStart'
        };
        vm.advancedCriteria.jobsReminderAtStart = {
                type: 'date',
                title: 'REMINDER_AT_START',
                value: (typeof $stateParams.jobsReminderAtStart !== 'undefined' && $stateParams.jobsReminderAtStart !== null) ? moment(new Date($stateParams.jobsReminderAtStart)) : null,
                maxDependsOn: 'jobsReminderAtEnd'
        };
        vm.advancedCriteria.jobsReminderAtEnd = {
                type: 'date',
                title: 'REMINDER_AT_END',
                end: true,
                value: (typeof $stateParams.jobsReminderAtEnd !== 'undefined' && $stateParams.jobsReminderAtEnd !== null) ? moment(new Date($stateParams.jobsReminderAtEnd)) : null,
                minDependsOn: 'jobsReminderAtStart'
        };
        vm.advancedCriteria.jobsAttendanceDueStart = {
                type: 'date',
                title: 'ATTENDANCE_DUE_AT_START',
                enableDisableJobsDueBy: true,
                value: (typeof $stateParams.jobsAttendanceDueStart !== 'undefined' && $stateParams.jobsAttendanceDueStart !== null) ? moment(new Date($stateParams.jobsAttendanceDueStart)) : null,
                maxDependsOn: 'jobsAttendanceDueEnd'
        };
        vm.advancedCriteria.jobsAttendanceDueEnd = {
                type: 'date',
                title: 'ATTENDANCE_DUE_AT_END',
                end: true,
                enableDisableJobsDueBy: true,
                value: (typeof $stateParams.jobsAttendanceDueEnd !== 'undefined' && $stateParams.jobsAttendanceDueEnd !== null) ? moment(new Date($stateParams.jobsAttendanceDueEnd)) : null,
                minDependsOn: 'jobsAttendanceDueStart'
        };
        vm.advancedCriteria.completedAtStart = {
                type: 'date',
                title: 'COMPLETED_AT_START',
                value: (typeof $stateParams.completedAtStart !== 'undefined' && $stateParams.completedAtStart !== null) ? moment(new Date($stateParams.completedAtStart)) : null,
                maxDependsOn: 'completedAtEnd'
        };
        vm.advancedCriteria.completedAtEnd = {
                type: 'date',
                title: 'COMPLETED_AT_END',
                end: true,
                value: (typeof $stateParams.completedAtEnd !== 'undefined' && $stateParams.completedAtEnd !== null) ? moment(new Date($stateParams.completedAtEnd)) : null,
                minDependsOn: 'completedAtStart'
        };
        vm.advancedCriteria.jobsOverdueCompletion = {
                type: 'options',
                title: 'OVERDUE_COMPLETION',
                value: $stateParams.jobsOverdueCompletion,
                options: overdueOptions
        };
        vm.advancedCriteria.jobsOverdueAttendance = {
                type: 'options',
                title: 'OVERDUE_ATTENDANCE',
                value: $stateParams.jobsOverdueAttendance,
                options: overdueOptions
        };
        vm.advancedCriteria.jobRequisitePendingCompletion = {
                type: 'options',
                title: 'JOB_REQUISITE_PENDING_COMPLETION',
                value: $stateParams.jobRequisitePendingCompletion,
                options: completionOptions
        };
        vm.advancedCriteria.jobRequisitePendingApproval = {
                type: 'options',
                title: 'JOB_REQUISITE_PENDING_APPROVAL',
                value: $stateParams.jobRequisitePendingApproval,
                multiple: true,
                options: approvalOptions
        };
        vm.advancedCriteria.jobSummary = {
                type: 'text',
                title: 'SUMMARY',
                value: $stateParams.jobSummary,
                class: 'full-width'
        };
        vm.advancedCriteria.description = {
                type: 'text',
                title: 'DESCRIPTION',
                value: $stateParams.description,
                class: 'full-width'
        };
        vm.advancedCriteria.location = {
            type: 'number',
            title: 'LOCATION_ID',
            value: $stateParams.location ? parseInt($stateParams.location, 10) : null
        };

        if (jobRequisiteCollectionResponse) {
            var selected = $stateParams.requisite ? {
                title: JSON.parse($stateParams.requisite).n,
                value: JSON.parse($stateParams.requisite).v
            } : null;

            vm.advancedCriteria.requisite = {
                type: 'jsonselectwidget',
                title: 'HAS_JOB_REQUISITE',
                value: $stateParams.requisite,
                options: {
                    mapValue: 'serviceProviderName',
                    onRemove: vm.saveParams,
                    onSelect: vm.saveParams,
                    response: jobRequisiteCollectionResponse,
                    responseKeyPath: 'jobRequisites',
                    itemValuePath: 'id',
                    itemTitlePath: 'name',
                    selected: selected,
                    loadmoreEnabled: true
                }
            };
        }

        if (!vm.p2p) {
            vm.advancedCriteria.jobStatus = {
                type: 'options',
                title: 'STATUS',
                multiple: true,
                value: $stateParams.jobStatus,
                options: jobStatuses.getAllTranslated()
            };
        }

        if (chargeTypesCollectionResponse && chargeTypesCollectionResponse.chargetypes && chargeTypesCollectionResponse.chargetypes.length !== 0) {
            let selectedChargeType = $stateParams.chargeType ? {
                title: JSON.parse($stateParams.chargeType).n,
                value: JSON.parse($stateParams.chargeType).v
            } : null;
            vm.advancedCriteria.chargeType = {
                type: 'jsonselectwidget',
                title: 'CHARGE_TYPES',
                value: $stateParams.chargeType,
                options: {
                    mapValue: 'chargeType',
                    onRemove: vm.saveParams,
                    onSelect: vm.saveParams,
                    itemValuePath: 'id',
                    itemTitlePath: 'name',
                    response: chargeTypesCollectionResponse,
                    responseKeyPath: 'chargetypes',
                    selected : selectedChargeType,
                    loadmoreEnabled: true
                }
            };
        }

        if (jobGroupCollectionResponse && jobGroupCollectionResponse.jobgroups && jobGroupCollectionResponse.jobgroups.length !== 0) {
            vm.advancedCriteria.jobGroups = {
                type: 'autocompletemulti',
                title: 'JOB_GROUP',
                param: 'jobGroups',
                multiple: true,
                value: $stateParams.jobGroups,
                options: {
                    autocompletemulti: true,
                    isHierarchical: true,
                    useIndentedHierarchy: true,
                    advanced: true,
                    onRemove: vm.saveParams,
                    onSelect: vm.saveParams,
                    response: jobGroupCollectionResponse,
                    link: jobGroupCollectionResponse.getLink('self'),
                    itemValuePath: 'name',
                    itemHrefPath: 'id',
                    mapValue: 'jobGroups',
                    responseKeyPath: 'jobgroups',
                }
            };
        }

        if (statutoryTypeCollectionResponse) {
            vm.advancedCriteria.statType = { type: 'options', title: 'JOB_STAT_TYPE', multiple: true, value: paramConverterService.checkStateParams($stateParams.statType), options: getStatTypes()}
        }

        if (rootResource.getLink('documenttypes')) {
            vm.documentTypeSelect = {
                link : rootResource.getLink('documenttypes'),
                linkParameters: { status: 'active', order: 'name' },
                responseKeyPath: 'documentTypes',
                onRemove: vm.saveParams,
                onSelect: vm.saveParams,
                mapValue: 'documentTypes',
                autocompletemulti: true,
                advanced: true,
                itemValuePath: 'name',
                itemHrefPath: 'id'
            };

            vm.advancedCriteria.documentTypes = {
                type: 'autocompletemulti',
                multiple: true,
                title: 'DOCUMENT_TYPE',
                options: vm.documentTypeSelect,
                param: 'documentTypes',
                value: $stateParams.documentTypes,
                max: 50
            };
        }

        vm.dueByModel = getDueBy();

        if ($stateParams.hasOwnProperty('jobsDueBy')) {
            vm.advancedCriteria.jobsDueBy = {
                type: 'jobsDueBy',
                title: 'JOBS_DUE_BY',
                value: JSON.parse($stateParams.jobsDueBy),
                options: vm.dueByModel,
                heightAuto: true,
            };
        }

        if (operativeCollectionResponse && operativeCollectionResponse.count > 0) {
            let selectedOperative = $stateParams.operative ? {
                title: JSON.parse($stateParams.operative).n,
                value: JSON.parse($stateParams.operative).v
            } : null;
            vm.advancedCriteria.operative = {
                type: 'jsonselectwidget',
                title: 'OPERATIVE',
                value: $stateParams.operative,
                options: {
                    mapValue: 'operative',
                    onRemove: vm.saveParams,
                    onSelect: vm.saveParams,
                    itemValuePath: '_links.user.id',
                    itemTitlePath: '_links.user.name',
                    itemHrefPath: '_links.user.href',
                    response: operativeCollectionResponse,
                    responseKeyPath: 'operatives',
                    selected : selectedOperative,
                    loadmoreEnabled: true,
                    linkParameters: { order: 'name' }
                }
            };
        }

        if (approversCollectionResponse && approversCollectionResponse.users && approversCollectionResponse.users.length !== 0) {
            let selectedSiteApprover = $stateParams.approver ? {
                title: JSON.parse($stateParams.approver).n,
                value: JSON.parse($stateParams.approver).v
            } : null;
            vm.advancedCriteria.approver = {
                type: 'jsonselectwidget',
                title: 'SITE_APPROVER',
                value: $stateParams.approver,
                options: {
                    mapValue: 'approver',
                    onRemove: vm.saveParams,
                    onSelect: vm.saveParams,
                    itemValuePath: 'id',
                    itemTitlePath: 'name',
                    response: approversCollectionResponse,
                    responseKeyPath: 'users',
                    selected: selectedSiteApprover,
                    loadmoreEnabled: true
                }
            };

            let approverByselected = $stateParams.jobApprovedByUser !== null ? {
                title: JSON.parse($stateParams.jobApprovedByUser).n,
                value: JSON.parse($stateParams.jobApprovedByUser).v
            } : null;

            vm.advancedCriteria.jobApprovedByUser = {
                type: 'jsonselectwidget',
                title: 'APPROVED_BY',
                value: $stateParams.jobApprovedByUser,
                options: {
                    mapValue: 'name',
                    onRemove: vm.saveParams,
                    onSelect: vm.saveParams,
                    response: approversCollectionResponse,
                    responseKeyPath: 'users',
                    itemValuePath: 'id',
                    itemTitlePath: 'name',
                    selected: approverByselected,
                    loadmoreEnabled: true
                }
            };
        }

        if (serviceProviderResponse && serviceProviderResponse.serviceproviders && serviceProviderResponse.serviceproviders.length !== 0) {
            let selected = $stateParams.serviceProvider ? {
                title: JSON.parse($stateParams.serviceProvider).n,
                value: JSON.parse($stateParams.serviceProvider).v
            } : null;

            vm.advancedCriteria.serviceProvider = {
                type: 'jsonselectwidget',
                title: 'SERVICE_PROVIDER',
                value: $stateParams.serviceProvider,
                options: {
                    mapValue: 'serviceProviderName',
                    onRemove: vm.saveParams,
                    onSelect: vm.saveParams,
                    response: serviceProviderResponse,
                    responseKeyPath: 'serviceproviders',
                    itemValuePath: 'id',
                    itemTitlePath: 'name',
                    selected: selected,
                    loadmoreEnabled: true
                }
            };
        }

        if (regionCollectionResponse && regionCollectionResponse.regions.length !== 0) {
            vm.advancedCriteria.jobSiteRegion = {
                type: 'autocompletemulti',
                title: 'REGIONS',
                multiple: true,
                isDisabled: selectDisabled,
                options: {
                    link : regionCollectionResponse.getLink('self'),
                    responseKeyPath: 'regions',
                    itemValuePath: 'name',
                    itemHrefPath: 'id',
                    mapValue: 'jobSiteRegion',
                    autocompletemulti: true,
                    advanced: true,
                    onRemove: vm.saveParams,
                    onSelect: vm.saveParams,
                    linkParameters: { order: 'name' }
                },
                param: 'jobSiteRegion',
                value: $stateParams.jobSiteRegion,
                max: 50
            };
        }

        if (userManager.user.getLink('sites') && $state.$current.self.name != 'dashboard.user.sites.list.details.jobs.list') {
            vm.siteSelect = {
                link : userManager.user.getLink('sites'),
                responseKeyPath: 'sites',
                itemValuePath: 'name',
                itemHrefPath: 'id',
                onRemove: vm.saveParams,
                onSelect: vm.saveParams,
                mapValue: 'siteIds',
                autocompletemulti: true,
                advanced: true,
                disabled: config.siteLevel || siteResource
            };

            if (siteCollection) {
                vm.siteSelect.cacheItems = lodash.map(siteCollection.sites, function(site) {
                    return {value: site.name, href: site.id, object:site};
                });
            }

            if (siteResource) {
                vm.siteSelect.cacheItems = [{value:siteResource.name, href:siteResource.id, object:siteResource}];
                $stateParams.siteIds = [siteResource.id];
            }

            vm.advancedCriteria.sites = { type: 'autocompletemulti', multiple: true, title: 'SITE', value: $stateParams.siteIds, options: vm.siteSelect, param: 'siteIds', max: 50 };
        }

        if (siteGroupCollection) {
            let siteGroupSelected = $stateParams.jobSiteGroup ? {
                title: JSON.parse($stateParams.jobSiteGroup).n,
                value: JSON.parse($stateParams.jobSiteGroup).v
            } : null;
            vm.advancedCriteria.jobSiteGroup = {
                type: 'jsonselectwidget',
                title: 'SITE_GROUP',
                value: $stateParams.jobSiteGroup,
                isDisabled: selectDisabled,
                options: {
                    mapValue: 'jobSiteGroup',
                    onRemove: vm.saveParams,
                    onSelect: vm.saveParams,
                    itemValuePath: 'id',
                    itemTitlePath: 'name',
                    response: siteGroupCollection,
                    responseKeyPath: 'sitegroups',
                    selected: siteGroupSelected,
                    loadmoreEnabled: true
                }
            };
        }

        if (priorityCollectionResponse) {
            vm.advancedCriteria.jobPriority = {
                type: 'options',
                title: 'JOB_PRIORITY',
                filterTitle: 'SELECT_PRIORITY',
                multiple: true,
                inputName: true,
                valueFilterByName: $stateParams.jobSpecificSpPriority,
                tempValueFilterByName: $stateParams.jobSpecificSpPriority,
                valueToShow: $stateParams.jobSpecificSpPriority,
                value: paramConverterService.checkStateParams($stateParams.jobPriority),
                options: getPriorities()
            };
        }

        if (creatorsCollectionResponse && creatorsCollectionResponse.count > 0) {
            let createdBySelected = $stateParams.createdBy ? {
                title: JSON.parse($stateParams.createdBy).n,
                value: JSON.parse($stateParams.createdBy).v
            } : null;
            vm.advancedCriteria.createdBy = {
                type: 'jsonselectwidget',
                title: 'CREATED_BY',
                value: $stateParams.createdBy,
                options: {
                    mapValue: 'createdBy',
                    onRemove: vm.saveParams,
                    onSelect: vm.saveParams,
                    itemValuePath: 'id',
                    itemTitlePath: 'name',
                    response: creatorsCollectionResponse,
                    responseKeyPath: 'users',
                    selected: createdBySelected,
                    loadmoreEnabled: true
                }
            };
        }

        var advancedCriteria = {}

        apiClient.get(jobCollectionResponse.getLink('reporters'), { datagroup: 'list', orderByUserName: 1 }).then(function(response) {
            if (response && response.count > 0) {
                // To get it in the right place otherwise it causes issues
                for (var key in vm.advancedCriteria) {
                    advancedCriteria[key] = vm.advancedCriteria[key];
                    if (key === 'createdBy') {
                        let reporterSelected = $stateParams.reporter ? {
                            title: JSON.parse($stateParams.reporter).n,
                            value: JSON.parse($stateParams.reporter).v
                        } : null;
                        advancedCriteria.reporter = {
                            type: 'jsonselectwidget',
                            title: 'REPORTER',
                            value: $stateParams.reporter,
                            options: {
                                mapValue: 'reporter',
                                link: response.getLink('self'),
                                onRemove: function() {
                                    params.reporter = null;
                                },
                                onSelect: vm.saveParams,
                                itemValuePath: 'id',
                                itemTitlePath: 'name',
                                response: response,
                                responseKeyPath: 'reporters',
                                selected: reporterSelected,
                                searchKey: 'reporterName',
                                itemHrefPath: 'id',
                                itemIdPath: 'name',
                                loadmoreEnabled: true
                            }
                        }
                    }
                }
                vm.advancedCriteria = advancedCriteria;
            }
        });

        if (sectorCollectionResponse) {
            let sectorSelected = $stateParams.sectors ? {
                title: JSON.parse($stateParams.sectors).n,
                value: JSON.parse($stateParams.sectors).v
            } : null;
            vm.advancedCriteria.sectors = {
                type: 'jsonselectwidget',
                title: 'SECTORS',
                value: $stateParams.sectors,
                options: {
                    mapValue: 'sectors',
                    onRemove: vm.saveParams,
                    onSelect: vm.saveParams,
                    itemValuePath: 'id',
                    itemTitlePath: 'name',
                    response: sectorCollectionResponse,
                    responseKeyPath: 'sectors',
                    selected: sectorSelected,
                    loadmoreEnabled: true,
                    linkParameters: { order: 'name' }
                }
            };
        }

        if (coreClientsCollectionResponse.coreclients) {
            let coreClientSelected = $stateParams.coreClient ? {
                title: JSON.parse($stateParams.coreClient).n,
                value: JSON.parse($stateParams.coreClient).v
            } : null;
            vm.advancedCriteria.coreClient = {
                type: 'jsonselectwidget',
                title: 'CORE_CLIENT',
                options: {
                    link: coreClientsCollectionResponse ? coreClientsCollectionResponse.getLink('self') : null,
                    mapValue: 'coreClient',
                    onRemove: vm.saveParams,
                    onSelect: vm.saveParams,
                    itemValuePath: 'id',
                    itemTitlePath: 'name',
                    response: coreClientsCollectionResponse,
                    responseKeyPath: 'coreclients',
                    selected: coreClientSelected,
                    loadmoreEnabled: true
                }
            };
        }

        if (serviceProviderGroupsResponse) {
            let serviceProviderGroupSelected = $stateParams.serviceProviderGroup ? {
                title: JSON.parse($stateParams.serviceProviderGroup).n,
                value: JSON.parse($stateParams.serviceProviderGroup).v
            } : null;
            vm.advancedCriteria.serviceProviderGroup = {
                type: 'jsonselectwidget',
                title: 'SERVICE_PROVIDER_GROUP',
                options: {
                    link: serviceProviderGroupsResponse ? serviceProviderGroupsResponse.getLink('self') : null,
                    mapValue: 'serviceProviderGroup',
                    onRemove: vm.saveParams,
                    onSelect: vm.saveParams,
                    itemValuePath: 'id',
                    itemTitlePath: 'name',
                    response: serviceProviderGroupsResponse,
                    responseKeyPath: 'groups',
                    selected: serviceProviderGroupSelected,
                    loadmoreEnabled: true
                }
            };
        }

        if (
            assetTypeCollectionResponse &&
            assetTypeCollectionResponse.assettypes &&
            assetTypeCollectionResponse.assettypes.length !== 0 &&
            vm.assetsModuleEnabled
        ) {
            let assetTypeSelected = $stateParams.assetTypes ? {
                title: JSON.parse($stateParams.assetTypes).n,
                value: JSON.parse($stateParams.assetTypes).v
            } : null;
            vm.advancedCriteria.assetTypes = {
                type: 'jsonselectwidget',
                title: 'ASSET_TYPES',
                options: {
                    mapValue: 'assetTypes',
                    onRemove: vm.saveParams,
                    onSelect: vm.saveParams,
                    itemValuePath: 'id',
                    itemTitlePath: 'name',
                    response: assetTypeCollectionResponse,
                    responseKeyPath: 'assettypes',
                    selected : assetTypeSelected,
                    loadmoreEnabled: true
                }
            };
        }

        if (assetCollectionResponse && assetCollectionResponse.count > 0 && vm.assetsModuleEnabled) {
            vm.assetModel = {
                assets: {
                    asset: $stateParams.asset ? JSON.parse($stateParams.asset) : null,
                    subasset: $stateParams.subAsset ? JSON.parse($stateParams.subAsset) : null,
                    clear: vm.clear
                },
                response: assetCollectionResponse,
            };

            vm.advancedCriteria.asset = {
                type: 'asset',
                title: 'ASSET',
                options: vm.assetModel
            };
        }

        vm.advancedCriteria.jobsRemedial = {
            type: 'options',
            title: 'REMEDIALS',
            value: $stateParams.jobsRemedial,
            options: remedialOptions
        };

        vm.advancedCriteria.sourceType = {
            type: 'autocompletemulti',
            multiple: true,
            title: 'SOURCE_TYPE',
            options: {
                items: sourceTypes,
                onRemove: vm.saveParams,
                onSelect: vm.saveParams,
                mapValue: 'sourceType',
                autocompletemulti: true
            },
            param: 'sourceType',
            value: $stateParams.sourceType,
            apiData: false
        };

        vm.advancedCriteria.watchedJobs = {
            type: 'options',
            title: 'WATCHED_JOBS',
            value: $stateParams.watchedJobs,
            options: watchedJobOptions
        };

        if (elbSettings.getSetting('meridian_enabled').value) {
            vm.advancedCriteria.externalSystem = {
                type: 'options',
                title: 'FROM_VANTIFY_RISK_MANAGER',
                value: $stateParams.externalSystem || null,
                options: fromVantifyRiskManagerOptions
            };
        }

        if (vm.prosureEnabled) {
            vm.advancedCriteria.prosureStatusAtApproval = {
                type: 'options',
                multiple: true,
                title: 'VANTIFY_SUPPLY_CHAIN_STATUS_AT_APPROVAL',
                value: $stateParams.prosureStatusAtApproval,
                options: prosureStatusesOptions
            };

            vm.advancedCriteria.prosureStatusAtCompletion = {
                type: 'options',
                multiple: true,
                title: 'VANTIFY_SUPPLY_CHAIN_STATUS_AT_COMPLETION',
                value: $stateParams.prosureStatusAtCompletion,
                options: prosureStatusesOptions
            };
        }

        vm.advancedCriteria.poNumber =  {
            type: 'text',
            title: 'PO_NUMBER',
            value: $stateParams.poNumber,
            class: 'full-width'
        };

        // Frequency and its interval share one cell and one label, but stay two separate state params
        vm.advancedCriteria.jobsFrequency = {
            type: 'frequency',
            title: 'FREQUENCY',
            value: $stateParams.jobsFrequency,
            options: frequencyOptions,
            pairedCriterion: 'jobsFrequencyInterval',
            updateValue: clearIntervalWithoutFrequency,
            onValueClear: clearFrequencyInterval
        };

        vm.advancedCriteria.jobsFrequencyInterval = {
            type: 'number',
            value: paramConverterService.clampToRange($stateParams.jobsFrequencyInterval, frequencyIntervalMin, frequencyIntervalMax),
            min: frequencyIntervalMin,
            max: frequencyIntervalMax,
            screenReaderLabel: 'FREQUENCY_INTERVAL_SCREEN_READER_LABEL',
            show: false
        };

        var params = {};

        // Drops an unsupported frequency on open
        if (hasUnsupportedFrequency()) {
            vm.advancedCriteria.jobsFrequency.value = null;
            params.jobsFrequency = null;
        }

        // Drops an interval with no frequency and caps an out of range one on open
        if (hasOrphanedFrequencyInterval()) {
            clearFrequencyInterval();
            params.jobsFrequencyInterval = null;
        } else if (hasCappedFrequencyInterval()) {
            params.jobsFrequencyInterval = vm.advancedCriteria.jobsFrequencyInterval.value;
        }

        function getPrioritiesBySite(selectedSites) {
            params.sites = selectedSites;
            var priorityLinkParameters = {'active': true, 'entityTypes': 'entity_type_all, entity_type_job', 'sites[]':selectedSites};

            apiClient.get(rootResource.getLink('priorities'), priorityLinkParameters).then(function(response) {
                vm.advancedCriteria.jobPriority = {
                    type: 'options',
                    title: 'JOB_PRIORITY',
                    multiple: true,
                    inputName: true,
                    value: null,
                    options: paramConverterService.formatResponse(response.priorities)
                };
            });
        }

        function getDueBy() {
            var options = {};
            if ($stateParams.jobsDueBy) {
                options = {
                    type: JSON.parse($stateParams.jobsDueBy).t,
                    frequency: JSON.parse($stateParams.jobsDueBy).f,
                    interval: JSON.parse($stateParams.jobsDueBy).i
                };
            }
            options.clear = vm.clear;

            if ($stateParams.completionDueStart !== null ||
                $stateParams.completionDueEnd !== null ||
                $stateParams.jobsAttendanceDueStart !== null ||
                $stateParams.jobsAttendanceDueEnd !== null
            ){
                options.isDisabled = true;
            } else {
                options.isDisabled = false;
            }

            return options;
        }

        function saveParams (selectModel) {
            if (selectModel && selectModel.callback) {
                selectModel.callback(selectModel.selected ? selectModel.selected.object.id : null);
            }

            // mapValue is for data select widget selections
            if (selectModel.mapValue) {
                if (typeof selectModel.autocompletemulti !== 'undefined'
                    && selectModel.autocompletemulti) {
                    params[selectModel.mapValue] = selectModel.selectedItems.map(
                        function (item) {
                            return item.href;
                        }
                    );
                } else {
                    if (selectModel.selected === undefined) {
                        params[selectModel.mapValue] = null;
                    } else {
                        if (selectModel.itemHrefPath === '_links.self.href') {
                            var itemIdPath = selectModel.itemIdPath ? selectModel.itemIdPath : 'id';
                            params[selectModel.mapValue] = selectModel.selected.object[itemIdPath];
                        } else {
                            params[selectModel.mapValue] = lodash.get(selectModel.selected.object, selectModel.itemIdPath);
                        }
                    }
                }
            } else if (selectModel) {
                // Remap criterion keys that have a `param` property to the correct state param key.
                // e.g. the directive builds a zipObject with key 'sites', but the state param is 'siteIds'.
                // First, collect all param targets so we can skip raw state-param keys that would collide.
                var paramTargets = {};
                lodash.forEach(vm.advancedCriteria, function(criterion, key) {
                    if (criterion.param && criterion.param !== key) {
                        paramTargets[criterion.param] = true;
                    }
                });
                var remapped = {};
                lodash.forEach(selectModel, function(value, key) {
                    var criterion = vm.advancedCriteria[key];
                    if (criterion && criterion.param) {
                        // For autocompletemulti criteria, always read the live selectedItems
                        // because criterion.value can be stale (set to [] by a prior scope.save()
                        // call before any items were selected).
                        if (criterion.type === 'autocompletemulti' && criterion.options && criterion.options.selectedItems) {
                            remapped[criterion.param] = criterion.options.selectedItems.map(function(item) {
                                return item.href;
                            });
                        } else {
                            remapped[criterion.param] = value;
                        }
                    } else if (!paramTargets[key]) {
                        // Only include if this key is not a raw state-param that
                        // was already remapped from a criterion key (e.g. skip 'siteIds'
                        // when 'sites' criterion already mapped to 'siteIds').
                        remapped[key] = value;
                    }
                });
                params = remapped;
            }

            if (selectModel.response && selectModel.response.count == 1 && selectModel.response.selected == null) {
                var url = selectModel.response.getLink('self').replace(/&?id=[0-9]+/g, '');
                selectModel.link = url;

                apiClient.get(url).then(function(response) {
                    selectModel.response = response;
                });
            }
        }

        function isEmptyValue(value) {
            return value === null || typeof value === 'undefined' || value === '';
        }

        function hasFrequency() {
            return !isEmptyValue(vm.advancedCriteria.jobsFrequency.value);
        }

        // True when the frequency is not one of the select options
        function hasUnsupportedFrequency() {
            return hasFrequency() && !frequencyOptions.some(function (option) {
                return option.value === String(vm.advancedCriteria.jobsFrequency.value);
            });
        }

        // True when the state carries an interval with no frequency
        function hasOrphanedFrequencyInterval() {
            return !hasFrequency() && !isEmptyValue($stateParams.jobsFrequencyInterval);
        }

        // True when the incoming interval differs from the capped value shown in the filter
        function hasCappedFrequencyInterval() {
            var rawInterval = $stateParams.jobsFrequencyInterval;

            return !isEmptyValue(rawInterval)
                && String(rawInterval) !== String(vm.advancedCriteria.jobsFrequencyInterval.value);
        }

        // Clears the interval when no frequency is selected
        function clearIntervalWithoutFrequency() {
            if (!hasFrequency()) {
                clearFrequencyInterval();
            }
        }

        function clearFrequencyInterval() {
            vm.advancedCriteria.jobsFrequencyInterval.value = null;
        }

        function close() {
            if (!$scope.form.$pristine) {
                if (!confirm($translate.instant('NAVIGATION_CONFIRMATION'))) {
                    return;
                }
            }
            $uibModalInstance.dismiss();
        }

        // Validate and update params with dueByModel
        function updateDueBy() {
            if (vm.dueByModel.type !== null && vm.dueByModel.selected !== null &&
                (
                    vm.dueByModel.frequency === null  ||
                    vm.dueByModel.frequency === undefined ||
                    vm.dueByModel.interval === undefined
                )
            ) {
                return false;
            }

            if (vm.dueByModel.selected === null) {
                params.jobsDueBy = null;
            } else {
                params.jobsDueBy = JSON.stringify({
                    t: vm.dueByModel.type,
                    f: vm.dueByModel.frequency,
                    i: vm.dueByModel.interval
                });
            }

            return true;
        }

        function updateAssetSubasset() {
            if (vm.assetModel && vm.assetModel.assets) {
                params.asset = vm.assetModel.assets.asset ? JSON.stringify(vm.assetModel.assets.asset) : null;
                params.subAsset = vm.assetModel.assets.subasset ? JSON.stringify(vm.assetModel.assets.subasset) : null;
            } else {
                params.asset = null;
                params.subAsset = null;
            }
        }

        function clear() {
            var clearValues = {};
            lodash.each($stateParams, function(value, key) {
                if (value) {
                   clearValues[key] = null;
                }
            });
            $state.go('.', angular.extend({}, clearValues), { reload: true });
            $uibModalInstance.dismiss();
        }

        function update() {
            if (Object.keys(params).length > 0) {
                params.jobsPage = '1';
            }

            // Job priority filter has like 2 filters in one, only one can be sent to the request
            if (params.jobPriority && params.jobSpecificSpPriority) {
                delete params.jobPriority;
            }

            // When clear or update clicked update params with dueByModel
            if (vm.dueByModel.type !== undefined) {
                var updateDueByHasError = !(updateDueBy());

                if (updateDueByHasError) {
                    return false;
                }
            }

            updateAssetSubasset();

            $rootScope.skipDirtyCheck = true;

            // Clear save filter if there are changes
            if (!lodash.isEmpty(params) && filterCriteriaService.checkFilterChanges(params)) {
                filterCriteriaService.setSelectedFilter(null);
            }

            $state.go('.', angular.extend({}, params), { reload: true });
            $uibModalInstance.dismiss();
        }
    }
})();
